var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDashboardIconSelected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.99122C0 3.74753 3.30065 0.274745 7.47482 0V7.99122C7.47482 8.09668 7.50605 8.19977 7.56457 8.2875L11.9997 14.9363C10.8247 15.6129 9.46193 16 8.00873 16C3.58563 16 0 12.4143 0 7.99122Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54265 7.4573V0C12.5403 0.26313 15.7368 3.45961 16 7.4573H8.54265Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00669 8.52514H16C15.8441 10.8933 14.6588 12.9803 12.8875 14.3429L9.00669 8.52514Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDashboardIconSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dashboardIconSelected.eee49f22adcacdd65c08f3894462b61c.svg";